import {
    AxnAttributeLabel,
    FormattedAxnAttributeLabel,
    AxnAttributeType
} from "@idw-types/data/reference-data/axn";

export const formatAxnAttributeLabels = (
    axnAttributeLabels: Array<AxnAttributeLabel>,
    axnAttributeTypes: Array<AxnAttributeType>,
): Array<FormattedAxnAttributeLabel> => {
    return axnAttributeLabels.map(label => formatAxnAttributeLabel(label, axnAttributeTypes));
};

export const formatAxnAttributeLabel = (
    axnAttributeLabel: AxnAttributeLabel,
    axnAttributeTypes: Array<AxnAttributeType>,
): FormattedAxnAttributeLabel => {
    const attributeType = axnAttributeTypes.find(at => at.id === axnAttributeLabel.attributeTypeID);

    return {
        id: axnAttributeLabel.id,
        label: axnAttributeLabel.label,
        attributeType: attributeType
    };
};